import React from "react"
import { Button, Flex, Input } from "antd"
import { SearchOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import CategorySelect from "components/common/CategorySelect"
import styles from "./index.module.css"

const EquipmentFilters = ({
  search,
  onSearchChange,
  selectedCategories,
  onCategoryChange,
  categoryOptions,
  onManageCategoriesClick,
  onAddEquipmentClick
}) => {
  const { t } = useTranslation()

  return (
    <Flex justify="space-between" wrap="wrap" gap={10} className={styles.filterWrap}>
      <Flex gap={16} align="center">
        <Input
          id="search"
          type="text"
          placeholder={t("listings.tabs.resources.equipment_placeholder") || "Search equipment..."}
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className={styles.searchInput}
          prefix={<SearchOutlined aria-hidden="true" />}
          allowClear
          aria-label={t("clients.search_clients") || "Search"}
        />
        <CategorySelect
          value={selectedCategories}
          onChange={onCategoryChange}
          options={categoryOptions}
          placeholder={t("Category") || "Category"}
          dropdownClassName={styles.dropdownButton}
        />
      </Flex>
      <Flex gap={16} align="center" className={`ml-auto ${styles.filterActions}`}>
        <Button
          color="primary"
          variant="outlined"
          size="large"
          aria-label="Manage Categories"
          className="flex-1"
          onClick={onManageCategoriesClick}
        >
          {t("listings.tabs.resources.manage_categories") || "Manage Categories"}
        </Button>
        <Button
          color="primary"
          variant="solid"
          size="large"
          aria-label={t("clients.import_client_list") || "Add Equipment"}
          className="flex-1"
          onClick={onAddEquipmentClick}
        >
          {t("listings.tabs.resources.add_equipment")}
        </Button>
      </Flex>
    </Flex>
  )
}

EquipmentFilters.propTypes = {
  search: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  selectedCategories: PropTypes.array.isRequired,
  onCategoryChange: PropTypes.func.isRequired,
  categoryOptions: PropTypes.array.isRequired,
  onManageCategoriesClick: PropTypes.func.isRequired,
  onAddEquipmentClick: PropTypes.func.isRequired
}

export default React.memo(EquipmentFilters)
